import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { AppointmentCTA } from "@/components/sections/AppointmentCTA";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  const categories = Array.from(new Set(faqs.map((f) => f.category)));
  const jsonLd = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })) };

  return (
    <>
      <Seo title="Frequently Asked Questions" description="Answers to common questions about treatments, recovery, and care at CDT." path="/faq" jsonLd={faqs.length ? jsonLd : null} />
      <PageHeader eyebrow="Questions & Answers" title="Frequently asked questions" subtitle="Clear, honest answers. If you don't find what you need, we're always happy to talk." />

      <section className="py-14 lg:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="faq-accordion">
          {categories.length > 0 && (
            <Tabs defaultValue={categories[0]}>
              <TabsList className="flex flex-wrap h-auto bg-transparent gap-2 justify-start mb-6">
                {categories.map((c) => (
                  <TabsTrigger key={c} value={c} data-testid={`faq-tab-${c}`} className="data-[state=active]:bg-[var(--cdt-primary)] data-[state=active]:text-white rounded-full border border-[color:var(--cdt-border)] px-4 text-xs">{c}</TabsTrigger>
                ))}
              </TabsList>
              {categories.map((c) => (
                <TabsContent key={c} value={c}>
                  <Accordion type="single" collapsible>
                    {faqs.filter((f) => f.category === c).map((f, i) => (
                      <AccordionItem key={i} value={`f-${i}`} className="border-[color:var(--cdt-border)]">
                        <AccordionTrigger className="text-left font-medium text-[var(--cdt-text)]">{f.question}</AccordionTrigger>
                        <AccordionContent className="text-[var(--cdt-muted)] leading-7">{f.answer}</AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </TabsContent>
              ))}
            </Tabs>
          )}
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
